<template>
  <div id="trs-main" class="crypt-register">
    <div class="container-crypt-register">
      <div class="page">
        <div class="page-ct">
          <div class="section">
            <div class="alert alert-danger" v-if="model.errorMessage != null">{{ $t(model.errorMessage) }}</div>
            <div class="section-inner">
              <form class="form-horizontal" v-show="!isConfirm" name="cryptoFxRegisForm" id="cryptoFxRegisForm" novalidate>
                <div class="panel-agreement">
                  <div class="box-ct">
                    <div style="margin-bottom: 2%">
                      <img style="height: 35px"  :src="cryptoLogo">
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.cryptoFX.regulationCryptoFX') }}</h2>
                      <div class="section-ct">
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <ul class="list-unstyled">
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_attention_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationAttentionCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_overview_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationOverviewCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_rules_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationRulesCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_insider_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationInsiderCoin') }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="right-part">
                              <div class="section-item-action">
                                <a class="btn btn-warning btn-select" @click="btnSelectClick($event)">{{ $t("customer.agree.accept") }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.cryptoFX.coinTrading') }}</h2>
                      <div class="section-ct section-ct-group">
                        <SectionBoxYesNo
                            itemContent="<p>暗号資産は本邦通貨または外国通貨（法定通貨）とは異なり、特定の国等によりその価値が保証されているものではなく、強制通用力を有しないことを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>暗号資産の価値は需給関係や様々な外部環境の変動によって常に変動するほか、プログラムに脆弱性や不具合が生じる可能性、悪意のある者による不正な取引等が行われる可能性等、予見の困難な事象により、暗号資産の価値が大きく下落するまたはゼロになる可能性があることを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>暗号資産には、ハードフォークにより暗号資産が2つに分岐し、相互に互換性がなくなる可能性があり、その場合、大幅な価値下落や取引が遡って無効になるリスクがあることを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>暗号資産証拠金取引は、元本や利益を保証するものではなく、レバレッジの効果により預託する証拠金の額以上の取引が可能となりますが、相場変動等により預託した証拠金の額を上回る損失が発生するおそれがあることを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>暗号資産証拠金取引において当社が提示する売付価格と買付価格には価格差（スプレッド）があり、相場変動等によりスプレッドが拡大する場合があり、お客様が意図する取引ができない可能性があることを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>証拠金不足が発生した場合、規定の証拠金維持率を回復するまで約定日時の古い建玉から順次決済が行われること（ロスカットの仕組み）を理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>ロスカットは必ずしもお客様の損失を限定するものではなく、相場変動等により、預託した証拠金以上の損失が発生するおそれあることを理解しました。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                        <SectionBoxYesNo
                            itemContent="<p>以下が禁止行為であることを理解しました。<br>
                                  ・お客様自身の名義で、ご家族を含む第三者に取引口座の開設及び取引をさせることはできないこと。<br>
                                  ・お客様自身の名義以外で、ご家族を含む第三者からのご入金は受付けられないこと。</p>"
                            v-on:clickBtnYes="checkHasQuestion()"
                            v-on:clickBtnNo="[checkHasQuestion(), openCancelModal()]">
                        </SectionBoxYesNo>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 class="section-title">{{ $t("bo_regis.investment_financial") }}</h2>
                <div class="form-group overflow-auto">
                  <label class="col-sm-2 control-label pl-0 float-left col-custom"><strong>{{ $t("trs.front.crypto.registration.label.purpose") }}</strong></label>
                  <div class="col-sm-6 float-left margin-custom">
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.cryptoPurposeFluctuationFlg" @change="checkHasQuestion"
                               :true-value="1" :false-value="0">
                        {{ $t("trs.front.crypto.registration.label.fluctuations.crypto.value" )}}
                      </label>
                    </div>
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.cryptoPurposeDiverseFlg" @change="checkHasQuestion"
                               :true-value="1" :false-value="0">
                        {{ $t("trs.front.crypto.registration.label.diversified.investment") }}
                      </label>
                    </div>
                    <div class="checkbox">
                      <label class="checkbox">
                        <input type="checkbox" v-model="input.cryptoPurposeAssetFlg" @change="checkHasQuestion"
                               :true-value="1" :false-value="0">
                        {{ $t("trs.front.crypto.registration.label.asset.formation") }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group overflow-auto clear-both" v-if="isCustomerIndividual">
                  <label class="control-label col-sm-2 col-xs-12 pl-0 float-left col-custom">
                    <strong>{{ $t("trs.front.crypto.registration.label.exp") }}</strong>
                  </label>
                  <div class="col-md-3 select-custom float-left nopadding-left nopadding-right">
                    <select class="form-control" v-model="input.cryptoInvestExp" @change="onChangeInvestExp">
                      <option v-for="item in mapCryptInvestExperiment"
                              :key="item.key" :value="item.key">
                        {{ $t(item.value) }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 select-custom float-left nopadding-left nopadding-right" v-if="showInvestExpSub">
                    <select class="form-control" v-model="input.cryptoInvestExpSub" @change="checkHasQuestion">
                      <option v-for="item in mapInvestExpSub"
                              :key="item.key" :value="item.key">
                        {{ $t(item.value) }}
                      </option>
                    </select>
                  </div>
                </div>

                <hr>
                <div class="alert alert-warning">
                  <div>
                    {{ $t("trs.front.crypto.registration.note") }}
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-action">
                    <button class="btn btn-lg btn-background-light-gray btn-padding-lg ml-1" @click="cancelAndReturnToHomePage()">
                      {{ $t("btn.go_to_cancel") }}
                    </button>
                    <button class="btn btn-lg btn-padding-lg ml-1" @click.prevent="saveRegistrationInfo()" id="btnSave" disabled>
                      {{ $t("btn.go_to_confirm") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <!-- confirm screen-->
            <div class="section-inner" v-if="isConfirm">
              <form class="form-horizontal">
                <div class="panel-agreement">
                  <div class="box-ct">
                    <div style="margin-bottom: 2%">
                      <img style="height: 33px" :src="cryptoLogo">
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.cryptoFX.regulationCryptoFX') }}</h2>
                      <div class="section-ct">
                        <div class="section-box">
                          <div class="box-item">
                            <div class="left-part">
                              <div class="section-box-item">
                                <ul class="list-unstyled">
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_attention_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationAttentionCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_overview_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationOverviewCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_rules_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationRulesCoin') }}
                                    </a>
                                  </li>
                                  <li>
                                    <a :href="minStHome + 'pdf/regulation_insider_coin.pdf'" target="_blank">
                                      <i class="far fa-file-pdf pr-1"></i>{{ $t('label.cryptoFX.regulationInsiderCoin') }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="right-part selected">
                              <div class="section-item-action">
                                <label class="">{{ $t("customer.agree.accept") }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="section">
                      <h2 class="section-title">{{ $t('label.cryptoFX.coinTrading') }}</h2>
                      <div class="section-ct section-ct-group">
                        <SectionBoxConfirm
                            itemContent="<p>暗号資産は本邦通貨または外国通貨（法定通貨）とは異なり、特定の国等によりその価値が保証されているものではなく、強制通用力を有しないことを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>暗号資産の価値は需給関係や様々な外部環境の変動によって常に変動するほか、プログラムに脆弱性や不具合が生じる可能性、悪意のある者による不正な取引等が行われる可能性等、予見の困難な事象により、暗号資産の価値が大きく下落するまたはゼロになる可能性があることを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>暗号資産には、ハードフォークにより暗号資産が2つに分岐し、相互に互換性がなくなる可能性があり、その場合、大幅な価値下落や取引が遡って無効になるリスクがあることを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>暗号資産証拠金取引は、元本や利益を保証するものではなく、レバレッジの効果により預託する証拠金の額以上の取引が可能となりますが、相場変動等により預託した証拠金の額を上回る損失が発生するおそれがあることを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>暗号資産証拠金取引において当社が提示する売付価格と買付価格には価格差（スプレッド）があり、相場変動等によりスプレッドが拡大する場合があり、お客様が意図する取引ができない可能性があることを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>証拠金不足が発生した場合、規定の証拠金維持率を回復するまで約定日時の古い建玉から順次決済が行われること（ロスカットの仕組み）を理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>ロスカットは必ずしもお客様の損失を限定するものではなく、相場変動等により、預託した証拠金以上の損失が発生するおそれあることを理解しました。</p>">
                        </SectionBoxConfirm>
                        <SectionBoxConfirm
                            itemContent="<p>以下が禁止行為であることを理解しました。<br>
                                  ・お客様自身の名義で、ご家族を含む第三者に取引口座の開設及び取引をさせることはできないこと。<br>
                                  ・お客様自身の名義以外で、ご家族を含む第三者からのご入金は受付けられないこと。</p>">
                        </SectionBoxConfirm>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 class="section-title">{{ $t("bo_regis.investment_financial") }}</h2>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">
                    <strong>{{ $t("trs.front.crypto.registration.label.purpose") }}</strong>
                  </label>
                  <div class="col-sm-6 float-left">
                    <div class="col-sm-7">
                      <p class="form-control-plaintext" v-if="input.cryptoPurposeFluctuationFlg === 1">
                        {{ $t("trs.front.crypto.registration.label.fluctuations.crypto.value") }}
                      </p>
                      <p class="form-control-plaintext" v-if="input.cryptoPurposeDiverseFlg === 1">
                        {{ $t("trs.front.crypto.registration.label.diversified.investment") }}
                      </p>
                      <p class="form-control-plaintext" v-if="input.cryptoPurposeAssetFlg === 1">
                        {{ $t("trs.front.crypto.registration.label.asset.formation") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="isCustomerIndividual">
                  <label class="col-sm-2 col-form-label">
                    <strong>{{ $t("trs.front.crypto.registration.label.exp") }}</strong>
                  </label>

                  <div class="col-sm-6">
                    <div class="col-sm-7">
                      <p class="form-control-plaintext" >{{ $t(investExp) }}</p>
                      <p class="form-control-plaintext" v-if="showInvestExpSub">{{ $t(investExpSub) }}</p>
                    </div>
                  </div>
                </div>

                <div class="form-action">
                  <button class="btn btn-lg btn-cancel btn-padding-lg btn-background-light-gray" @click="backToInput()">{{ $t("btn.back") }}</button>
                  <button type="button" class="btn btn-lg btn-success btn-padding-lg" @click="confirmRegister()" data-toggle="modal" id="btnRegist">{{ $t("customer.agree.accept") }}</button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IConstants from "@/common/constants/IConstants";
import $ from "jquery";
import {createNamespacedHelpers} from "vuex";
import * as TYPE from "@/store/modules/crypto-registration/type";
import * as NEWS_TYPE from "@/store/modules/news/type";
import * as HEADER_TYPE from "@/store/modules/header/type";
import SectionBoxYesNo from "@/components/base/SectionBoxYesNo";
import cryptoRedirectMixin from '@/common/mixins/cryptoRedirect';
import SectionBoxConfirm from "@/components/base/SectionBoxConfirm";

const {mapActions: mapCryptoRegistrationActions} = createNamespacedHelpers('cryptoRegistration');
const {mapActions: mapNewsActions} = createNamespacedHelpers('news');
const {mapState: mapHeaderState, mapActions: mapHeaderActions} = createNamespacedHelpers('header');

export default {
    mixins:[cryptoRedirectMixin],
    components: {SectionBoxYesNo, SectionBoxConfirm},
    data() {
        return {
            SERVICE_NAME: 'cryptoRegistration',
            model: {
                errorMessage: null
            },
            investExp: "",
            investExpSub: "",
            isConfirm: false,
            showInvestExpSub: false,
            cryptoLogo: IConstants.LINK_ASSETS.CRYPTO_LOGO,
            minStHome: IConstants.WEB_LINK.MIN_ST_HOME,
            input: {
                cryptoPurposeFluctuationFlg: 0,
                cryptoPurposeDiverseFlg: 0,
                cryptoPurposeAssetFlg: 0,
                cryptoInvestExp: -1,
                cryptoInvestExpSub: -1
            },
            mapCryptInvestExperiment: IConstants.getMapInvestExperiment(),
            mapInvestExpSub: IConstants.getMapInvestExperimentSub(),
        }
    },
    created() {
        this[TYPE.INIT_CRYPTO_REGISTRATION_FLAGS]();
        this.redirectCryptoRegistration();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm[NEWS_TYPE.FORCE_SET_AGREE_FLG](true);
            vm[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](false);
        });
    },
    beforeRouteLeave(to, from, next) {
        this[NEWS_TYPE.FORCE_SET_AGREE_FLG](false);
        this[HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN](true);
        next();
    },
    computed: {
        ...mapHeaderState({
            corpType: state => state.headerInfo.corporationType,
        }),

        isCustomerIndividual: function () {
            return this.corpType === 0;
        },

        isCustomerCorp: function () {
            return this.corpType === 1;
        },
    },
    methods: {
        ...mapCryptoRegistrationActions([TYPE.INIT_CRYPTO_REGISTRATION_FLAGS]),

        ...mapNewsActions([NEWS_TYPE.FORCE_SET_AGREE_FLG]),

        ...mapHeaderActions([HEADER_TYPE.SET_DISPLAY_OFF_CANVAS_BTN, HEADER_TYPE.SET_ACTIVE_TAB_ID]),

        btnSelectClick(event) {
            $(event.target).parents('.right-part').toggleClass('selected');
            $(event.target).toggleClass('selected');
            $(event.target).parents(".box-item").toggleClass('answered');
            this.checkHasQuestion();
        },

        btnDefaultClick(event) {
            $(event.target).parents('.right-part').removeClass('selected');
            $(event.target).parents(".box-item").removeClass('answered');
            $(event.target).parents('.right-part').find('.btn-select').removeClass('selected');
            this.checkHasQuestion();
        },

        checkHasQuestion() {
            let allAnswered = this.input.cryptoPurposeDiverseFlg === 1
                || this.input.cryptoPurposeAssetFlg === 1
                || this.input.cryptoPurposeFluctuationFlg === 1;

            if (this.isCustomerIndividual) {
                if (this.input.cryptoInvestExp === -1 || (this.input.cryptoInvestExp === 1 && this.input.cryptoInvestExpSub === -1)) {
                    allAnswered = false;
                }
            }

            $(".box-item").each(function () {
                if (!$(this).hasClass('answered')) {
                    allAnswered = false;
                }
            });

            if (allAnswered) {
                $("#btnSave").addClass("btn-success");
                $("#btnSave").removeAttr("disabled");
            } else {
                $("#btnSave").removeClass("btn-success");
                $("#btnSave").prop('disabled', true);
            }
        },

        openCancelModal() {
            this.$modal.openCryptoRegistrationCancelModal();
        },

        onChangeInvestExp() {
            this.showInvestExpSub = (this.input.cryptoInvestExp === 1);
            if (this.showInvestExpSub) {
                this.input['cryptoInvestExpSub'] = -1;
            } else {
                this.investExpSub = '';
                this.input['cryptoInvestExpSub'] = null;
            }

            this.checkHasQuestion();
        },

        cancelAndReturnToHomePage() {
            this[HEADER_TYPE.SET_ACTIVE_TAB_ID](HEADER_TYPE.MENU_HOME);
            this.$router.push({name: "home"});
        },

        saveRegistrationInfo() {
            if (this.invalidSelfAssets()) {
                return;
            }

            let config = new FormData();
            config.append("cryptoInvestExp", this.input.cryptoInvestExp);
            config.append("cryptoInvestExpSub", this.input.cryptoInvestExpSub);
            config.append("cryptoPurposeAssetFlg", this.input.cryptoPurposeAssetFlg);
            config.append("cryptoPurposeDiverseFlg", this.input.cryptoPurposeDiverseFlg);
            config.append("cryptoPurposeFluctuationFlg", this.input.cryptoPurposeFluctuationFlg);

            this.$service
                .getService(this.SERVICE_NAME)
                .saveCryptoRegister(config)
                .then(response => {
                    if (response.redirect !== null && IConstants.CRYPTO_PAGE.DOWNLOAD_CRYPTO_APP === response.redirect) {
                        this.gotoDownloadApp();
                    }
                    if (response.errorMessage && response.errorMessage !== '') {
                        this.model = response;
                    } else {
                        window.scrollTo(0, 0);
                        this.isConfirm = true;
                        this.model = response;

                        if (this.isCustomerIndividual) {
                            let exp = this.input.cryptoInvestExp;
                            let self = this;
                            Object.keys(this.mapCryptInvestExperiment).forEach(function (key) {
                                if (self.mapCryptInvestExperiment[key]["key"] === exp) {
                                    self.investExp = self.mapCryptInvestExperiment[key]["value"];
                                }
                            });

                            let expSub = this.input.cryptoInvestExpSub;
                            Object.keys(this.mapInvestExpSub).forEach(function (key) {
                                if (self.mapInvestExpSub[key]["key"] === expSub) {
                                    self.investExpSub = self.mapInvestExpSub[key]["value"];
                                }
                            });
                        } else {
                            this.investExp = '';
                        }
                    }
                });
        },

        invalidSelfAssets() {
            if (this.isCustomerIndividual) {
                if (this.input.cryptoInvestExp === -1)
                    return true;
                else {
                    if (this.input.cryptoInvestExp === 1 && this.input.cryptoInvestExpSub === -1)
                        return true;
                }
            }
            if (this.input.cryptoPurposeAssetFlg !== 1
                && this.input.cryptoPurposeDiverseFlg !== 1
                && this.input.cryptoPurposeFluctuationFlg !== 1) {
                return true;
            }
            return false;
        },

        gotoDownloadApp() {
            this.$root.$emit(this.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
            this.$router.push({name: "downloadCryptoApp"});
        },

        backToInput() {
            this.model.errorMessage = null;
            this.isConfirm = false;
        },

        confirmRegister() {

            let config = new FormData();
            config.append("cryptoInvestExp", this.input.cryptoInvestExp);
            config.append("cryptoInvestExpSub", this.input.cryptoInvestExpSub);
            config.append("cryptoPurposeAssetFlg", this.input.cryptoPurposeAssetFlg);
            config.append("cryptoPurposeDiverseFlg", this.input.cryptoPurposeDiverseFlg);
            config.append("cryptoPurposeFluctuationFlg", this.input.cryptoPurposeFluctuationFlg);

            this.$service
                .getService(this.SERVICE_NAME)
                .confirmCryptRegister(config)
                .then((response) => {
                    this.model = response;

                    if (!response.errorMessage) {
                        this.model.errorMessage = null;
                        this.$router.push({name: "cryptoUploadDocument"});
                    } else {
                        window.scrollTo(0, 0);
                        this.model.errorMessage = response.errorMessage;
                    }
                });
        }
    },
}

</script>

<style scoped>
.btn-warning {
  margin-right: 2px;
  color: white !important;
}

.btn-success:hover {
  color: #fff;
  background-color: #449d44;
  border-color: #398439
}

.clear-both{
  clear: both;
}
.container-crypt-register {
  margin-right: auto;
  margin-left: auto;
}
.margin-custom{
  margin-left: -15px;
}
.checkbox{
  margin-bottom: 0.5rem;
}
@media (min-width: 1200px) {
  .container-crypt-register {
    width: 1140px;
  }
}

@media (min-width: 768px) {
  .select-custom {
    margin-right: 20px;
  }

  #btnRegist {
    margin-left: 5px;
  }
}
@media (max-width: 767px) {
  .col-custom {
    max-width: 100%;
  }
  .form-action .btn{
    margin-bottom: 10px
  }
}
</style>
